/**
 *  @internal Provide this constant as 4th param to the
 *  computeTicketBasePrice method to ignore optional.
 */
export const IGNORE_OPTIONAL = true;
/**
 *  @internal Action to use to update an applied VAT amount in a VAT collection.
 */
export var VATUpdateAction;
(function (VATUpdateAction) {
    VATUpdateAction["Add"] = "add";
    VATUpdateAction["Subtract"] = "subtract";
})(VATUpdateAction || (VATUpdateAction = {}));
//# sourceMappingURL=types.js.map